module.exports = __webpack_public_path__ + "static/media/papaya-transparent.cf88a0ea.png";